var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isServerAvailable)?_c('div',[_c('router-view')],1):_c('div',[_c('DeadServer')],1),_c('GoTop',{attrs:{"z-index":9000,"right":25,"bg-color":'#b89453'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }